import * as React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';

const CustomInputAdornment = (props) => {
    return <InputAdornment {...props} />;
};

export { CustomInputAdornment as InputAdornment };
